module.exports = __webpack_public_path__ + "img/bhutan.5d8bb188.svg";